var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroku(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C9S0WqyY81FUT1Xdr9f50a",
    x1: 32,
    x2: 32,
    y1: 7,
    y2: 57,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#C9S0WqyY81FUT1Xdr9f50a)",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M12,51.636V12.364 C12,9.954,13.99,8,16.444,8h31.111C50.01,8,52,9.954,52,12.364v39.273C52,54.046,50.01,56,47.556,56H16.444 C13.99,56,12,54.046,12,51.636z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C9S0WqyY81FUT1Xdr9f50b",
    x1: 31.498,
    x2: 31.498,
    y1: 13.875,
    y2: 48.751,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C9S0WqyY81FUT1Xdr9f50b)",
    d: "M42,30.554V49h-7V30.5c0-0.25-0.26-0.5-1.25-0.5c-1.556,0-4.519,0.321-11.125,2.875 c0,0-0.375,0.125-0.614,0.125C20.875,33,21,31.25,21,31.25V14h7v11c1.535-0.471,4.215-1,6.75-1C39.477,24,42,26.237,42,30.554z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C9S0WqyY81FUT1Xdr9f50c",
    x1: 38.5,
    x2: 38.5,
    y1: 13.875,
    y2: 48.751,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C9S0WqyY81FUT1Xdr9f50c)",
    d: "M44,14.03l-0.43,1.283c-0.036,0.116-0.906,2.673-3.516,6.31L39.785,22H33l1.193-1.573 c1.596-2.103,3.033-5.78,3.051-5.818l0.233-0.579H44z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C9S0WqyY81FUT1Xdr9f50d",
    x1: 24,
    x2: 24,
    y1: 14.083,
    y2: 48.869,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C9S0WqyY81FUT1Xdr9f50d)",
    d: "M27 43L21 49 21 37z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/heroku.6e7d0ea3a2e7897bbaa93b6213ee37bc.svg";
export { ForwardRef as ReactComponent };